import React from 'react';
import {connect} from 'react-redux'
import {Flex} from '/app/src/component';
import SVG from 'react-inlinesvg'
import {List} from 'immutable'
import Theme from '/app/src/theme';
import Pagination from '/app/src/component/Pagination'

import SortButton from './SortButton'
import QuestionItem from './QuestionItem'
import {FeedbackModel, FeedbackSelector} from '/app/src/model'
import * as FAQSelector from '/app/src/model/FAQ/selector';

import style from './style.css'
class Questions extends React.Component {
    constructor(props) {
        super(props);
        this.onClick = this.onClick.bind(this)
        this.onClickListItem = this.onClickListItem.bind(this)
        this.state = {
            sortingKey: 'positive',
            currentPage: 1,
        }

        this._onPaginationClick = this._onPaginationClick.bind(this);

    }

    componentDidMount() {
        const {sortingKey} = this.state
        this.props.dispatchCurrentItem(null)
        this.props.dispatchQuestions('helpdesk', sortingKey, 1)
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevState.sortingKey !== this.state.sortingKey) {
            this.props.dispatchQuestions('helpdesk', this.state.sortingKey, 1)
        }
    }

    onClick(sortingKey) {
        this.setState({sortingKey: sortingKey})
        this.props.dispatchCurrentItem(null)
    }

    onClickListItem(questionId) {
        this.props.dispatchCurrentItem(questionId)
    }

    _onPaginationClick(index){
        const {sortingKey} = this.state
        this.props.dispatchCurrentItem(null)
        this.props.dispatchQuestions('helpdesk', sortingKey, index)
        this.setState({currentPage: index})
    }

    _renderQuestions() {
        const { questions, order, feedbackStats , currentItem} = this.props
        let questionsCmp = []
        for (let i = 0; i < order.size; i++) {
            const questionId = order.get(i).toString()
            const question = questions.getIn([questionId, 'question'])
            const nbrPositive = feedbackStats[questionId]['positive']
            const nbrNegative = feedbackStats[questionId]['negative']
            const categoryId = questions.getIn([questionId, 'category_id']);
            const visible = questions.getIn([questionId, 'visible']);

            questionsCmp.push(
                <QuestionItem
                    {...{question, nbrPositive, nbrNegative, currentItem, questionId, categoryId, visible}}
                    onClick={() => this.onClickListItem(questionId)}
                    key={i}
                />
            );
        }
        return questionsCmp
    }

    _renderNoFeedback() {
        return (
            <Flex className={style.NoPostsText} w='100%' h='100%' center>
                Det finns inga artiklar med feedback än.
            </Flex>
        )
    }

    render() {
        const posIcon = <SVG style={{fill: Theme.colors.green1}} className={style.Icon} src='/images/emojiSmile2.svg' cacheGetRequests={true}/>
        const postsIcon = <SVG style={{fill: Theme.colors.grey2}} className={style.Icon} src='/images/Conversations_M.svg' cacheGetRequests={true}/>
        const negIcon = <SVG style={{fill: Theme.colors.red1}} className={style.Icon} src='/images/emojiUnhappy.svg' cacheGetRequests={true}/>

        const { questions, questionsCount } = this.props
        const { currentPage, sortingKey } = this.state;

        return (
            <Flex column>
                <Flex className={style.SortHelpText} center shrink={0}>
                    Sortera efter feedback.
                </Flex>
                <Flex center shrink={0}>
                    <SortButton icon={posIcon} active={sortingKey === 'positive'} text='Positiva' onClick={() => this.onClick('positive')}/>
                    <SortButton icon={postsIcon} active={sortingKey === 'discussed'} text='Skrivet' onClick={() => this.onClick('discussed')} />
                    <SortButton icon={negIcon} active={sortingKey === 'negative'} text='Negativa' onClick={() => this.onClick('negative')} />
                </Flex>
                <div className={style.QuestionsListWrapper}>
                    <Flex className={style.QuestionsList} column grow w='100%'>
                        {questions.size === 0 ? this._renderNoFeedback() : this._renderQuestions()}
                    </Flex>
                </div>
                <Flex>
                {questions.size > 15 && <Pagination marginTop='auto'
                    itemCounts={questionsCount}
                    itemPerPage={15}
                    currentPage={currentPage}
                    onClick={this._onPaginationClick}
                />}
                </Flex>
            </Flex>
        )
    }
}

const {selector: questionsSelector, dispatcher: dispatchQuestions} = FeedbackModel.readQuestions();

const mapDispatchToProps = (dispatch, props) => {
    return {
        'dispatchQuestions': (systemType, sortingKey, offset) => dispatch(dispatchQuestions(systemType, sortingKey, offset)),
        'dispatchCurrentItem': (currentItem) => dispatch(FeedbackModel.setCurrentItem(currentItem))
    }

}

function _countFeedback(feedback) {
    const feedbackArray = {}
    for (let i = 0; i < feedback.size; i++) {
        const currentFeedback = feedback.get(i)
        const questionId = FeedbackSelector.getFeedbackSystemId(currentFeedback)
        const rating = FeedbackSelector.getFeedbackRating(currentFeedback)
        if (!(questionId in feedbackArray)) {
            feedbackArray[questionId] = {}
            feedbackArray[questionId]['positive'] = 0;
            feedbackArray[questionId]['negative'] = 0;
        }
        if (rating === 1) feedbackArray[questionId]['positive']++
        else if (rating === -1) feedbackArray[questionId]['negative']++
    }
    return feedbackArray
}

function mapStateToProps(state, props) {
    let feedback = questionsSelector(state, 'helpdesk')
    const questionsCount = feedback.getIn(['questions', 'questions_total']);

    const order = feedback.getIn(['questions', 'order'], List([]))
    feedback = feedback.getIn(['questions', 'feedbacks'], List([]))
    const questions = FAQSelector.getFAQs(state);
    const feedbackStats = _countFeedback(feedback);
    const currentItem = FeedbackSelector.getCurrentItem(state);




    return { feedback, order, questions, feedbackStats, questionsCount, currentItem}
}

export default connect(mapStateToProps, mapDispatchToProps)(Questions)



// WEBPACK FOOTER //
// ./src/layout/Dashboard/MainPanel/ClientChatSettings/FAQ/Helpdesk/Feedback/Questions/index.js